import { ApiError } from "./ApiError";

export default class ConflictError extends ApiError {
  code = 409;
}
